import { createSelector } from 'reselect';
import { applicationPropertiesSelector as propertiesSelector } from './properties';

export const applicationIncludeGooglePalNonceSelector = createSelector(
  [propertiesSelector],
  ({ setup }) => setup.includeGooglePalNonce,
);
